export default {
    namespaced: true,
    state: {
        notifications: {}
    },
    mutations: {
        set_notifications(state, notifications){
            state.notifications = notifications;
        },
        reset_notifications(state){
            state.notifications = {};
        },
    },
    getters: {
        notifications: state => state.notifications,
    },
    actions: {
        loadNotifications({commit, rootState}, user){
            const url = laravel.config.app_url + '/dealer/api/v2/users/' + rootState.account.user.id + '/notifications';
              return new Promise((resolve, reject) => {
                  axios.get(url)
                      .then(response => {
                        commit('set_notifications',response.data.notifications);
                        resolve();
                      })
                      .catch(err => {
                          commit('reset_notifications');
                          reject(err);
                      });
              })
        },
        update({commit}, notifications) {
            commit('set_notifications', notifications);
        }
    },

};
